module.exports = __webpack_public_path__ + "assets/credit-card.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/credit-card.jpg
 ** module id = 212
 ** module chunks = 1
 **/